import { js_utils } from "./frfr-js-utils";
// import { tempkeyCounter } from "../ter/frfr-draftel-counter-utils";


/*
FrFr FRIENDLY FRAMEWORK
frfr-protobomp-utils
Version ID: 1a 2024-08-17r1
by 
// Please describe here if you customized this file
*/


/*
DOKUMENTACIJA:
- naziv ključa za svaki prtobel je "tempkey" što treba da asocira da taj ključ ne treba da igra izvan strukture podataka jednog protobomp-a.

*/


////
const _protobomp_example_make = () => {
  return {
    thisis: 'PROTOBOMP',
    protobomp_version: "2",
    counter: 3,
    tempkey: null, // mozda null ili 0 ???
    // type_is_primitive: false,
    // pbnode_class: 'ROOT_ASSEMBLY',
    // allow_delete: false,
    entities: [
      {
        tempkey: 1,
        parent_tempkey: null,
        type_is_primitive: true,
        pbnode_class: 'PRIMITIVE_TER_PROFIL',
        allow_delete: false,
        // keyvals: {},
        state: {},
      },
      {
        tempkey: 2,
        parent_tempkey: null,
        type_is_primitive: true,
        pbnode_class: 'PRIMITIVE_TER_PROFIL',
        allow_delete: false,
        // keyvals: {},
        state: {},
      },
      {
        tempkey: 3,
        parent_tempkey: null,
        type_is_primitive: true,
        pbnode_class: 'PRIMITIVE_TER_LIM',
        allow_delete: false,
        // keyvals: {},
        state: {},
      },
      {
        tempkey: 4,
        parent_tempkey: null,
        type_is_assembly: false,
        type_is_primitive: false,
        pbnode_class: 'ASSEMBLY_TER_SKLOP',
        allow_delete: false,
        // keyvals: {},
        state: {},
      },
    ],
  };
};
////




//
export const protobomp_validator_quick_incomplete = (protobomp) => {
  let valid = true;
  // TEST 1)
  if (protobomp && protobomp.type_is_protobomp === true && protobomp.thisis === 'PROTOBOMP') {
    // TEST 2)
    if (protobomp.manifest) {
      // is valid so far
      // TEST 3)
      if (Array.isArray(protobomp.entities)) {
        // TEST 4)
        if (protobomp.counter === 0 || protobomp.counter > 0) {
          // is valid so far
        } else {
          // TEST 4 FAIL
          valid = false;
          // console.log('INVALID - protobomp.counter not a valid number');
        }
      } else {
        // TEST 3 FAIL
        valid = false;
        // console.log('INVALID - protobomp.entities not an array');
      }
    } else {
      // TEST 2 FAIL
      valid = false;
      // console.log('INVALID - protobomp.manifest not exist');
    }
  } else {
    // TEST 1 FAIL
    valid = false;
    // console.log('INVALID - ');
  }
  return valid;
};


//
export const protobomp_utils_entity_create_primitive = () => {
  const new_entity = {
    customkey: null, // named key
    type_is_primitive: true,
    type_is_assembly: false,
    pbnode_class: null,
    state: {},
  };
  return new_entity;
};
//
export const protobomp_utils_entity_create_assembly = (options) => {
  const new_entity = {
    customkey: null, // named key
    type_is_primitive: false,
    type_is_assembly: true,
    pbnode_class: null,
    options: {
      allow_delete: true,
      allow_add_btns: true,
    },
    state: {},
  };
  if (options && options.allow_delete === true || options.allow_delete === false) {
    new_entity.options.allow_delete = options.allow_delete;
  }
  if (options && options.allow_add_btns === true || options.allow_add_btns === false) {
    new_entity.options.allow_add_btns = options.allow_add_btns;
  }
  return new_entity;
};
//
export const protobomp_utils_entity_create_progressive_assembly = (options) => {
  const new_entity = {
    customkey: null, // named key
    type_is_primitive: false,
    type_is_assembly: true,
    type_is_assembly_progressive: true,
    pbnode_class: null,
    options: {
      allow_delete: true,
      allow_add_btns: true,
    },
    state: {},
  };
  if (options && options.allow_delete === true || options.allow_delete === false) {
    new_entity.options.allow_delete = options.allow_delete;
  }
  if (options && options.allow_add_btns === true || options.allow_add_btns === false) {
    new_entity.options.allow_add_btns = options.allow_add_btns;
  }
  return new_entity;
};


//
export const protobomp_utils_get_superdata = (protobomp) => {
  //
  return protobomp.superdata;
};


//
export const protobomp_utils_extract_pbnode_arr = (protobomp) => {
  return protobomp.entities;
};


//
export const protobomp_utils_get_children_of_pbnode = (protobomp, parent_tempkey) => {
  // if parent_tempkey is null than you get root levele entities
  const children_pbnode_arr = protobomp.entities.filter((pbnode) => {
    if (pbnode.parent_tempkey === parent_tempkey) {
      return true;
    }
    return false;
  });
  return children_pbnode_arr;
};


//
export const protobomp_utils_get_entity_state_by_customkey = (protobomp, customkey) => {
  // not returning 
  let bingo_pbnode = {};
  if (protobomp && Array.isArray(protobomp.entities)) {
    let finished = false;
    let i = 0;
    let maxi = protobomp.entities.length - 1;
    while (i <= maxi && finished === false) {
      const pbnode = protobomp.entities[i];
      if (pbnode && pbnode.customkey && (typeof pbnode.customkey === 'string') && pbnode.customkey === customkey) {
        bingo_pbnode = pbnode;
        finished = true;
      }
      i++;
    } // end of while
  }
  return bingo_pbnode;
};


//
export const protobomp_manipulator = {};


//
protobomp_manipulator.init = (manifest, superdata = {}) => {
  const new_protobomp = {
    thisis: 'PROTOBOMP',
    type_is_protobomp: true,
    protobomp_version: "2",
    counter: 0,
    /*
    manifest: { // TODO
      options: { // protobomp root options
        allow_root_btns: false,
      },
    },
    options: { // protobomp root options
      allow_root_btns: false,
    },
    */
    manifest,
    superdata,
    entities: [],
    index_obj: {}, // TODO
    index_for_tempkey: {}, // TODO
  };
  /*
  if (options && (options.allow_root_btns === true || options.allow_root_btns === false)) {
    new_protobomp.options.allow_root_btns = options.allow_root_btns;
  }
  */
  /*
  if (js_utils.is_object(superdata)) {
    new_protobomp.superdata = superdata;
  }
  */
  return new_protobomp;
};


//
protobomp_manipulator.deinit = (protobomp_ref) => {
  // ONLY FOR INSTANCES
  // DEREFERENCE
  const protobomp_dereferenced = {
    ...protobomp_ref,
    entities: [...protobomp_ref.entities]
  }; // NEW OBJECT REFERENCE
  protobomp_ref = {}; // DEREFERENCED
  return protobomp_dereferenced;
};


//
protobomp_manipulator.delete_pbnode_and_all_descendants = (protobomp_ref, tempkey) => {
  let _ids_to_be_deleted = [tempkey];
  // preparing ids to be deleted
  const arr = protobomp_ref.entities;
  const _each = (arr, parent_tempkey) => {
    arr.forEach(pbnode => {
      if (pbnode.parent_tempkey === parent_tempkey) {
        const tempkey = pbnode.tempkey;
        _ids_to_be_deleted.push(tempkey);
        // recursive call
        _each(arr, tempkey);
      }
    });
  };
  _each(arr, tempkey); // initial call
  // deleting
  const updated_arr = arr.filter(pbnode => {
    if (_ids_to_be_deleted.includes(pbnode.tempkey)) {
      return false; // delete
    }
    return true; // stay in array
  });
  //
  /*
  const updated_protobomp = {
    ...protobomp,
    entities: updated_arr
  }; // NEW REFERENCE
  */
  // SAME REF
  protobomp_ref.entities = updated_arr;
  const updated_protobomp = protobomp_ref;
  // return updated_protobomp;
  return {
    updated_protobomp, //
  };
};


//
const _special_returning_instance = (tempkey) => {
  // TODO cilj je da se formira jednostavnija sintaksa u kojoj bi se korstila specijalna kvazi instanca poput fdb...
  let instance = {}; // new instance...
  instance.parent_tempkey = tempkey;
  instance.add_child = tempkey = (protobomp, raw_entity) => {
    const parent_tempkey = tempkey;
    protobomp_manipulator.add(protobomp, raw_entity, parent_tempkey);
  };
  return instance;
};


//
protobomp_manipulator.add = (protobomp_ref, raw_entity, parent_tempkey) => {
  const fresh_tempkey = protobomp_ref.counter + 1;
  //
  const new_entity = {
    // pbnode_class: entbox.meta.pbnode_class,
    customkey: null,
    pbnode_class: null,
    state: {
      // ...entbox.state,
      ...raw_entity.state,
    },
    tempkey: fresh_tempkey,
    parent_tempkey: parent_tempkey
  };
  // required/mandatory fields
  new_entity.type_is_primitive = raw_entity.type_is_primitive;
  new_entity.type_is_assembly = raw_entity.type_is_assembly;
  if (raw_entity.type_is_assembly_progressive === true) {
    new_entity.type_is_assembly_progressive = true;
  }
  new_entity.options = raw_entity.options;
  // new_entity.props = raw_entity.props; // TODO
  // optional fields
  if (typeof raw_entity.pbnode_class === 'string') {
    new_entity.pbnode_class = raw_entity.pbnode_class;
  }
  if (typeof raw_entity.customkey === 'string' && raw_entity.customkey !== '') {
    new_entity.customkey = raw_entity.customkey;
  }
  //
  let updated_arr = [...protobomp_ref.entities, new_entity];
  //
  /*
  const updated_protobomp = {
    ...protobomp_ref,
    counter: fresh_tempkey,
    entities: updated_arr
  }; // NEW REFERENCE
  */
  // return updated_protobomp;
  //
  // SAME REF
  protobomp_ref.counter = fresh_tempkey;
  protobomp_ref.entities = updated_arr;
  const updated_protobomp = protobomp_ref;
  //
  return {
    updated_protobomp, //
    created_tempkey: fresh_tempkey
  };
};


//
protobomp_manipulator.update_pbnode = (protobomp_ref, tempkey, editedState) => {
  const arr = protobomp_utils_extract_pbnode_arr(protobomp_ref);
  let updated_arr = arr.map(pbnode => {
    if (pbnode.tempkey === tempkey) {
      return {
        ...pbnode,
        state: {
          ...editedState,
        },
        // tempkey: tempkey
      }; // UPDATE
    }
    return pbnode;
  });
  //
  /*
  const updated_protobomp = {
    ...protobomp,
    entities: updated_arr
  }; // NEW REFERENCE
  */
  // SAME REF
  protobomp_ref.entities = updated_arr;
  const updated_protobomp = protobomp_ref;
  // return updated_protobomp;
  return {
    updated_protobomp,
  };
};


//
protobomp_manipulator.duplicate_pbnode = (protobomp_ref, target_tempkey) => {
  //
  const arr = protobomp_ref.entities;
  const bingo_pbnode = arr.find((pbnode) => {
    if (pbnode.tempkey === target_tempkey) {
      return true;
    }
    return false;
  });
  if (bingo_pbnode) {
    let _ids_already_cloned = [];
    let updated_arr = [];
    //
    // cloning bingo_pbnode and preserve old nodes
    const bingo_freshkey = protobomp_ref.counter + 1;
    arr.forEach((pbnode) => {
      updated_arr.push(pbnode); // preserve old node
      if (pbnode.tempkey === target_tempkey) {
        _ids_already_cloned.push(target_tempkey);
        // also add new duplicate entity after old
        // duplicate bingo pbnode...
        const new_entity = js_utils.pure_clone_by_json(pbnode);
        if (typeof new_entity.customkey === 'string' && new_entity.customkey !== '') {
          delete new_entity.customkey; // remove customkey if exist. Because that cant be duplicate
        }
        new_entity.tempkey = bingo_freshkey;
        protobomp_ref.counter = bingo_freshkey;
        updated_arr.push(new_entity);
      }
    });
    //
    // cloning children of bingo pbnode...
    let fresh_tempkey = bingo_freshkey;
    const _each = (arr, parent_tempkey, new_parent_tempkey) => {
      arr.forEach(pbnode => {
        const tempkey = pbnode.tempkey;
        if (_ids_already_cloned.includes(tempkey)) {
          // skip
        } else {
          if (pbnode.parent_tempkey === parent_tempkey) {
            _ids_already_cloned.push(tempkey);
            // duplicate...
            fresh_tempkey++;
            const new_entity = js_utils.pure_clone_by_json(pbnode);
            if (typeof new_entity.customkey === 'string' && new_entity.customkey !== '') {
              delete new_entity.customkey; // remove customkey if exist. Because that cant be duplicate
            }
            new_entity.tempkey = fresh_tempkey;
            new_entity.parent_tempkey = new_parent_tempkey; //
            protobomp_ref.counter = fresh_tempkey;
            updated_arr.push(new_entity);
            // recursive call
            _each(arr, tempkey, fresh_tempkey);
          }
        }
      });
    };
    _each(arr, target_tempkey, bingo_freshkey); // initial call
    //
    protobomp_ref.entities = updated_arr;
    const updated_protobomp = protobomp_ref;
    // return updated_protobomp;
    return {
      updated_protobomp, // SAME REF CHANGED
    };
  } else {
    return {
      updated_protobomp: protobomp_ref, // SAME REF UNCHANGED
    }
  }
};


//
const _convert_from_flat_to_nestedPbnodeTree = (protobomp_ref) => {
  // virbom hierarchical tree nested from flat (normalized)
  let nestedPbnodeTree = [];
  const entities_arr = protobomp_utils_extract_pbnode_arr(protobomp_ref);
  if (Array.isArray(entities_arr) && entities_arr[0]) {
    //
    const _dirty_tree_pbnode_single = (pbnode, _parent_tempkey) => {
      // pozivanje iteracija za children elemente
      const parent_tempkey = pbnode.tempkey;
      const children_pbnode_arr = protobomp_utils_get_children_of_pbnode(entities_arr, parent_tempkey);
      // console.log('children');
      // console.log(children_pbnode_arr);
      // let target_graphlevel = this_graphlevel + 1;
      const nested_children_arr = _dirty_tree_pbnode_each(children_pbnode_arr, parent_tempkey);
      // create pbnode_with_nested_children
      return {
        self: pbnode,
        nested_children: nested_children_arr
      };
    }; // end of _dirty_tree_pbnode_single
    //
    const _dirty_tree_pbnode_each = (_pbnodeArr, _parent_tempkey) => {
      let _children_arr = [];
      _pbnodeArr.forEach((pbnode) => {
        // console.log('each');
        // console.log(pbnode);
        if (pbnode.parent_tempkey === _parent_tempkey) {
          const pbnode_with_nested_children = _dirty_tree_pbnode_single(pbnode, _parent_tempkey);
          _children_arr.push(pbnode_with_nested_children);
        }
      });
      return _children_arr;
    }; // end of _dirty_tree_pbnode_each
    //
    // startovanje iteracija pocev od level 1
    nestedPbnodeTree = _dirty_tree_pbnode_each(entities_arr, null);
  }
  return nestedPbnodeTree;
};


//
const _move_pbnode = (protobomp_ref, target_tempkey, to_prev) => {
  //
  const arr = protobomp_ref.entities;
  let updated_arr = arr;
  let is_bingo_found = false;
  let bingo_pbnode = false;
  let bingo_parent_tempkey = null;
  let bingo_parent_index = -1;
  let bingo_parent_of_parent_tempkey = null;
  let _bingo_prev_index = -1;
  let _bingo_next_index = -1;
  //
  const bingo_index = arr.findIndex((pbnode) => {
    if (pbnode.tempkey === target_tempkey) {
      return true;
    }
    return false;
  });
  if (bingo_index > -1) {
    is_bingo_found = true;
    bingo_pbnode = arr[bingo_index];
    // STEP searching for parent... ???
    if (bingo_pbnode && bingo_pbnode.parent_tempkey > 0) {
      bingo_parent_tempkey = bingo_pbnode.parent_tempkey;
      bingo_parent_index = arr.findIndex((pbnode) => {
        if (pbnode.tempkey === bingo_parent_tempkey) {
          return true;
        }
        return false;
      });
      if (bingo_parent_index > -1) {
        const bingo_parent_of_parent = arr[bingo_parent_index];
        if (bingo_parent_of_parent && bingo_parent_of_parent.parent_tempkey > 0) {
          bingo_parent_of_parent_tempkey = bingo_parent_of_parent.parent_tempkey;
        }
      }
    }
  }
  //
  if (is_bingo_found) {
    /*

    */
    ////
    /*
    let i = 0;
    while (exit === false) {
      if (i < arr.length) {
        const pbnode = arr[i];
        */
    // STEP analyse
    let _prev_index_in_same_parent = -1;
    let _next_index_in_same_parent = -1;
    let _prev_parent_index = -1;
    let _prev_parent_tempkey = null;
    let _next_parent_index = -1;
    let _next_parent_tempkey = null;
    // let _preprev_parent_tempkey = null;
    // let _current_parent_tempkey = null;
    arr.forEach((pbnode, index) => {
      if (pbnode.parent_tempkey === bingo_parent_tempkey) {
        // same parent
        if (index < bingo_index && index > _prev_index_in_same_parent) {
          _prev_index_in_same_parent = index;
        }
        if (index > bingo_index && (index < _next_index_in_same_parent || _next_index_in_same_parent === -1)) {
          _next_index_in_same_parent = index;
        }
      } else {
        // other parents
        if (pbnode.type_is_assembly === true && pbnode.tempkey === bingo_parent_of_parent_tempkey) {
          // one level above parent
          // TODO
        }
      }
    });
    // STEP swap
    if (to_prev === true) {
      // same parent MOVE TO PREV
      if (_prev_index_in_same_parent > -1) {
        updated_arr = [];
        const forward_index = _prev_index_in_same_parent; // FORWARD MOVING ITEM
        const forward_item = arr[_prev_index_in_same_parent]; // FORWARD MOVING ITEM
        const backward_index = bingo_index; // BACKWARD REPLACING ITEM
        const backward_item = bingo_pbnode; // BACKWARD REPLACING ITEM
        // swap
        updated_arr = [...arr];
        updated_arr[forward_index] = backward_item;
        updated_arr[backward_index] = forward_item;
      }
    } else {
      // same parent MOVE TO NEXT
      if (_next_index_in_same_parent > -1) {
        const forward_index = bingo_index; // FORWARD REPLACING ITEM
        const forward_item = bingo_pbnode; // FORWARD REPLACING ITEM
        const backward_index = _next_index_in_same_parent; // BACKWARD MOVING ITEM
        const backward_item = arr[_next_index_in_same_parent]; // BACKWARD MOVING ITEM
        // swap
        updated_arr = [...arr];
        updated_arr[forward_index] = backward_item;
        updated_arr[backward_index] = forward_item;
      }
    }
    /*
  } else {
    exit = true;
  }
  i++;
}
*/
    ////
  } else {
    // no changes
  }
  /////
  /*
  // STEP analyse
  let _preprev_parent_tempkey = null;
  let _prev_parent_tempkey = null;
  let _current_parent_tempkey = null;
  let _next_parent_tempkey = null;
  let exit = false;
  let i = 0;
  while (exit === false) {
    if (i < arr.length) {
      const pbnode = arr[i];
      if (pbnode.tempkey === target_tempkey) {
        // BINGO
        is_bingo_found = true;
        _current_parent_tempkey = pbnode.parent_tempkey;
        if (_current_parent_tempkey === _prev_parent_tempkey) {
          _prev_parent_tempkey = _preprev_parent_tempkey;
          _preprev_parent_tempkey = null;
        }
      }
      //
      if (_current_parent_tempkey > 0 && pbnode.tempkey === _current_parent_tempkey) {

      }
      if (is_bingo_found === false) {

      } else {
        if (_next_index > -1) {
        } else {
          _next_parent_tempkey = pbnode.tempkey;
        }
        _next_index = i;
      }
      //
      if (pbnode.type_is_assembly === true) {
        if (is_bingo_found === false) {
          _preprev_parent_tempkey = _prev_parent_tempkey;
          _prev_parent_tempkey = pbnode.tempkey;
        } else {
          if (_next_parent_tempkey > 0) {
          } else {
            _next_parent_tempkey = pbnode.tempkey;
          }
          //
          if (_next_parent_tempkey > 0) {
            // analyzing finished
            exit = true;
          }
        }
      }
    } else {
      exit = true;
      if (condition) {

      }
    }
    i++;
  }
  */
  //
  // SAME REF
  protobomp_ref.entities = updated_arr;
  const updated_protobomp = protobomp_ref;
  // return updated_protobomp;
  return {
    updated_protobomp,
  };
};
//
protobomp_manipulator.move_pbnode_to_prev = (protobomp_ref, target_tempkey) => {
  return _move_pbnode(protobomp_ref, target_tempkey, true);
}
//
protobomp_manipulator.move_pbnode_to_next = (protobomp_ref, target_tempkey) => {
  return _move_pbnode(protobomp_ref, target_tempkey, false);
}
